import { ID } from 'shared/types/id';

const storageKey = 'push-notification-tokens';

const getPushNotificationTokens = (): Record<ID, string> => {
  const tokensStr = window.localStorage.getItem(storageKey);
  try {
    const tokens = tokensStr ? JSON.parse(tokensStr) ?? {} : {};
    return tokens;
  } catch (e) {
    return {};
  }
};

export const getPushNotificationToken = (uid: ID) =>
  getPushNotificationTokens()[uid];
export const getUidByPushNotificationToken = (token: string) => {
  const tokens = getPushNotificationTokens();
  return Object.keys(tokens).find((key) => tokens[key] === token);
};

export const setPushNotificationToken = (uid: string, token: string) =>
  window.localStorage.setItem(storageKey, JSON.stringify({ [uid]: token }));

export const clearPushNotificationTokens = () =>
  window.localStorage.removeItem(storageKey);

export const removePushNotificationToken = (uid: ID) => {
  const tokens = getPushNotificationTokens();
  delete tokens[uid];
  window.localStorage.setItem(storageKey, JSON.stringify(tokens));
};
